import Button from "atoms/button/button";
import Heading from "atoms/heading/heading";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import React from "react";
import Modal from "atoms/modal/modal";
import Sheet from "atoms/sheet/sheet";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import "./deleteModal.scss";
import Loader from "atoms/loader";
import { getLoadingStatus } from "./selectors";
import { useSelector } from "react-redux";

interface Props {
  hideModal: React.MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
  modalTitle: string;
  title: string; 
  handleDeleteClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const ThetaDeleteModal = (props: Props) => {
  const { hideModal, modalTitle, title, handleDeleteClick } = props;
  const loading = useSelector((state) => getLoadingStatus(state));

  return (
    <Modal hideModal={hideModal}>
      <Sheet isInset>
        <SheetBody>
          <Stack isVertical gutter="small" className="common-modal-content">
            <StackItem isStretch className="common-modal-header">
              <Heading isSecondary> Delete {modalTitle.toUpperCase()} </Heading>
            </StackItem>
            {loading ? (
              <StackItem isGrow isStretch align="center">
                <Loader />
              </StackItem>
            ) : (
              <StackItem isGrow className="common-modal-body">
                <Stack isVertical gutter="medium">
                  <StackItem isStretch>
                    <Heading type="secondary">
                      Would you like to delete {title}?
                    </Heading>
                  </StackItem>
                </Stack>
              </StackItem>
            )}
          </Stack>
        </SheetBody>
        <StackItem isStretch className="p-0">
          <Stack className="common-modal-actions">
            <StackItem>
              <Button
                isText
                name="No, Do Not Delete"
                isSecondary
                handleClick={hideModal}
                disabled={loading}
              />
            </StackItem>
            <StackItem isStretch align="right">
              <Button
                isPrimary
                name={`Yes, Delete ${modalTitle.toUpperCase()}`}
                handleClick={handleDeleteClick}
                disabled={loading}
              />
            </StackItem>
          </Stack>
        </StackItem>
      </Sheet>
    </Modal>
  );
};

export default ThetaDeleteModal;
